import { NewsMore } from './'

class NewsArchiveApi {
  constructor(el) {
    this.dom = {el: el};

    this.yearData = {};
    this.yearArray = [];

    this.url = '/ja/news_files/json/news.json';
    this.html = null;

    this.init();
  }

  init() {
    const _this = this;

    fetch(this.url,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    )
    .then(response => {
      return response.json();
    })
    .then(json => {
      let data = json.items;
      data.sort(function(a, b) {
        return (a.date > b.date) ? -1 : 1; // 日付順にソート
      });

      // 年パターンを取得
      data.forEach(d=>{
        const year = d.date.substring(0, 4);
        if (!this.yearArray.includes(year))
          this.yearArray.push(year)
      })
      
      // 年毎に記事をまとめる
      this.yearArray.forEach((y, i)=>{
        this.yearData[`y${String(y)}`] = data.filter(d => {
          return y === d.date.substring(0, 4)
        })
      })

      this.dom.el.innerHTML = this.createHtml(this.yearData);

      const domMoreButton = document.querySelector('[data-js="more"]');
      if (domMoreButton) new NewsMore(domMoreButton);
    });
  }

  createHtml(_data) {
    this.html = '';
    Object.entries(this.yearData).forEach(([key, value], i) => {
      this.html += `
        <section class="ns-achievement-unit"${(i >= 2) ? ' data-display="none"' : ''}>
          <h2 class="ns-achievement-unit__year">${key.substring(1, 5)}</h2>
          <ul class="ns-achievement__lists">
      `;

      value.forEach(data=>{
        const date = data.date.split('-').join('.');

        // 同ドメイン以外のリンク先の場合は別タブで開く
        const external = (!data.url.startsWith(window.location.origin)) ? ' target="_blank"' : '';
        // ファイル名の取得
        // let file = data.url.split('/').reverse()[0];
        // クエリパラメータの削除
        // file = file.replace(/\?.*$/, '');
  
        this.html += `
          <li class="ns-achievement-list">
            <a href="${data.url}"${external} class="ns-achievement-list__inner">
              <time datetime="${data.date}" class="ns-achievement-list__time">${date}</time>
              <span class="ns-achievement-list__title">${data.title}</span>
            </a>
          </li>
        `;
      })

      this.html += `
          </ul>
        </section>
      `;
    })
    return this.html;
  }
}

export default NewsArchiveApi
